import { makeStyles } from "@material-ui/core/styles";

// D8.24.1 — Estilos.
export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  card: {
    marginBottom: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.mode === 'dark' 
      ? '0 2px 8px rgba(0,0,0,0.3)' 
      : '0 2px 8px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: theme.mode === 'dark' 
        ? '0 4px 16px rgba(0,0,0,0.5)' 
        : '0 4px 16px rgba(0,0,0,0.15)',
    },
  },
  cardHeader: {
    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
    color: 'white',
    padding: theme.spacing(2),
    borderRadius: '12px 12px 0 0',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  cardContent: {
    padding: theme.spacing(2),
  },
  metricBox: {
    padding: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#f8f9fa',
    border: `2px solid ${theme.mode === 'dark' ? '#4B5563' : '#e9ecef'}`,
    marginBottom: theme.spacing(2),
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#e3f2fd',
      transform: 'translateY(-2px)',
    },
  },
  metricLabel: {
    fontSize: '12px',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
    fontWeight: 500,
  },
  metricValue: {
    fontSize: '32px',
    fontWeight: 'bold',
    color: theme.palette.text.primary,
  },
  metricUnit: {
    fontSize: '14px',
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(0.5),
  },
  progressBar: {
    marginTop: theme.spacing(1),
    height: 8,
    borderRadius: 4,
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#e5e7eb',
    '& .MuiLinearProgress-bar': {
      borderRadius: 4,
    },
  },
  chartContainer: {
    marginTop: theme.spacing(2),
    height: 300,
    [theme.breakpoints.down('sm')]: {
      height: 250,
    },
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 400,
  },
  alertCard: {
    padding: theme.spacing(2),
    borderRadius: 8,
    marginBottom: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  alertInfo: {
    backgroundColor: theme.mode === 'dark' ? '#1e3a8a' : '#dbeafe',
    border: `2px solid ${theme.mode === 'dark' ? '#3b82f6' : '#60a5fa'}`,
    color: theme.mode === 'dark' ? '#93c5fd' : '#1e40af',
  },
  alertWarning: {
    backgroundColor: theme.mode === 'dark' ? '#78350f' : '#fef3c7',
    border: `2px solid ${theme.mode === 'dark' ? '#f59e0b' : '#fbbf24'}`,
    color: theme.mode === 'dark' ? '#fcd34d' : '#92400e',
  },
  alertError: {
    backgroundColor: theme.mode === 'dark' ? '#7f1d1d' : '#fee2e2',
    border: `2px solid ${theme.mode === 'dark' ? '#dc2626' : '#ef4444'}`,
    color: theme.mode === 'dark' ? '#fca5a5' : '#991b1b',
  },
  alertCritical: {
    backgroundColor: theme.mode === 'dark' ? '#450a0a' : '#fee2e2',
    border: `2px solid ${theme.mode === 'dark' ? '#dc2626' : '#ef4444'}`,
    color: theme.mode === 'dark' ? '#fca5a5' : '#991b1b',
  },
  table: {
    minWidth: 650,
  },
  tableRow: {
    '&:hover': {
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
    },
  },
}));
